import React, { useEffect } from "react";
import { Upload, Progress } from "@arco-design/web-react";
import { IconPlus, IconEdit } from "@arco-design/web-react/icon";
import HeaderComponent from "@arco-design/web-react/es/Layout/header";
import HeaderSection from "../../Components/HeaderSection";
import { Tab, Tabs } from "react-bootstrap";
import { formateString, getLocalStorage } from "../../Functions/Utils";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import {
  DIRECTAIMENUS,
  MENUSWITHOUTCAPTUREOPTION,
  routeList,
} from "../../globalData/constant";
import { useLocation } from "react-router-dom";
import VersionSelector from "../../Components/VersionSelector/VersionSelector";

function Uploadfiles({
  handleFileUpload,
  selectedData,
  dataList,
  setUploadSide,
  setisToggled,
  headerName,
  isToggled,
  fileUploaded,
  setFileUploaded,
  documentSideKeys,
  setSelectedSide,
  selectedSide,
  Loader,
  accept,
  selectedMenu,
  onCameraCapture,
}) {
  const [file, setFile] = React.useState();
  const cs = `arco-upload-list-item${
    file && file.status === "error" ? " is-error" : ""
  }`;
  const handleSelect = (data, index) => {
    if (DIRECTAIMENUS?.includes(selectedMenu)) {
      if (getLocalStorage("currentBase64")) {
        selectedData(data);
        setUploadSide(false);
      }
    } else {
      selectedData(data);
      setUploadSide(false);
    }
  };

  const location = useLocation();
  const currentPath = location.pathname;

  useEffect(() => {
    if (fileUploaded) {
      setFileUploaded(false);
      DIRECTAIMENUS?.includes(selectedMenu)
        ? selectedMenu === "UAEVISAOCR"
          ? handleSelect(dataList?.data, 0)
          : handleSelect(dataList?.detail, 0)
        : handleSelect(dataList[0], 0);
    }
  }, [fileUploaded]);

  // useEffect(() => {
  //   alert(Loader)
  // }, [Loader])

  return (
    <>
      <div className="px-3 flex-fill">
        <HeaderSection
          handleToggleBtn={() => setisToggled(!isToggled)}
          headerName={headerName}
        />
        <div className="d-flex justify-content-center  py-3 tab_custom_content">
          {documentSideKeys && (
            <Tabs
              // defaultActiveKey={documentSideKeys[0]}
              activeKey={selectedSide}
              id="tab_id"
              className="nav_tab_t1 nav-pills gap-3"
              onSelect={(key) => {
                setSelectedSide(key);
              }}
            >
              {documentSideKeys.map((itm, index) => (
                <Tab
                  eventKey={itm.value}
                  key={index}
                  title={formateString(itm.key).replace("Reader", "")}
                  active={itm.value == selectedSide}
                  className="nav-item nav-link ps-0"
                ></Tab>
              ))}
            </Tabs>
          )}
        </div>
        <div className="upload_section overflow-auto scrollbar1">
          <div className="align-items-center py-md-0 py-4 d-block d-md-flex h-100 justify-content-center m-auto">
            <div className="pb-4 pb-md-0">
              <div className="mb-2 d-flex justify-content-center">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="142"
                  height="161"
                  viewBox="0 0 142 161"
                  fill="none"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M8.11401 51.5707C8.11401 49.4107 9.86504 47.6597 12.025 47.6597H54.109C56.269 47.6597 58.02 49.4107 58.02 51.5707V67.1465H137.06C139.512 67.1465 141.5 69.1341 141.5 71.586V156.395C141.5 158.847 139.512 160.835 137.06 160.835H12.5536C10.1017 160.835 8.11407 158.847 8.11407 156.395V81.9422L8.11401 81.9213V51.5707Z"
                    fill="#004C92"
                  />
                  <rect
                    x="23.2548"
                    y="0.165405"
                    width="113.103"
                    height="128.43"
                    fill="#F6F6F6"
                  />
                  <rect
                    x="31.9755"
                    y="9.15018"
                    width="95.6616"
                    height="5.18445"
                    fill="#E4E4E4"
                  />
                  <rect
                    x="31.9755"
                    y="26.5912"
                    width="95.6616"
                    height="4.22814"
                    fill="#E4E4E4"
                  />
                  <rect
                    x="31.9755"
                    y="35.576"
                    width="95.6616"
                    height="4.22814"
                    fill="#E4E4E4"
                  />
                  <rect
                    x="31.9755"
                    y="44.5608"
                    width="95.6616"
                    height="4.22814"
                    fill="#E4E4E4"
                  />
                  <rect
                    x="31.9755"
                    y="53.5456"
                    width="95.6616"
                    height="4.22814"
                    fill="#E4E4E4"
                  />
                  <rect
                    x="31.9755"
                    y="62.5304"
                    width="95.6616"
                    height="4.22814"
                    fill="#E4E4E4"
                  />
                  <rect
                    x="31.9755"
                    y="71.5152"
                    width="95.6616"
                    height="4.22814"
                    fill="#F6F6F6"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M0 60.6278C0 58.4678 1.75103 56.7167 3.91103 56.7167H46.0338C48.1938 56.7167 49.9449 58.4678 49.9449 60.6278L49.9449 68.3442V71.6474C49.9449 72.9887 50.6252 75.3802 53.1056 76.0077H129.54C131.991 76.0077 133.979 77.9953 133.979 80.4472V156.395C133.979 158.847 131.991 160.835 129.54 160.835H4.43955C1.98766 160.835 0 158.847 0 156.395V90.5947V80.4472V60.6278Z"
                    fill="#1A82E2"
                  />
                  <g filter="url(#filter0_d_64_936)">
                    <path
                      d="M69.1156 132.559H65.6563V111.803L56.1429 121.316L53.6868 118.86L67.386 105.161L81.0851 118.86L78.629 121.316L69.1156 111.803V132.559Z"
                      fill="white"
                    />
                  </g>
                  <defs>
                    <filter
                      id="filter0_d_64_936"
                      x="51.5727"
                      y="105.161"
                      width="31.6265"
                      height="31.6265"
                      filterUnits="userSpaceOnUse"
                      color-interpolation-filters="sRGB"
                    >
                      <feFlood flood-opacity="0" result="BackgroundImageFix" />
                      <feColorMatrix
                        in="SourceAlpha"
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        result="hardAlpha"
                      />
                      <feOffset dy="2.11407" />
                      <feGaussianBlur stdDeviation="1.05703" />
                      <feComposite in2="hardAlpha" operator="out" />
                      <feColorMatrix
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
                      />
                      <feBlend
                        mode="normal"
                        in2="BackgroundImageFix"
                        result="effect1_dropShadow_64_936"
                      />
                      <feBlend
                        mode="normal"
                        in="SourceGraphic"
                        in2="effect1_dropShadow_64_936"
                        result="shape"
                      />
                    </filter>
                  </defs>
                </svg>
              </div>
              <h2 className="font_15 fw-light pt-3 mb-2 text-center">
                This model is ready to extract !
              </h2>
              {/* Reusable Version Selector Component */}
              <VersionSelector selectedMenu={selectedMenu} />
              <h3 className="text_master2 font_15 pt-2 mb-0 text-center">
                Click to add files you want to process{" "}
              </h3>

              <div className=" text-center w-100 pb-4 pb-md-0">
                <div className="d-flex justify-content-center my-3 align-items-center gap-2 flex-column flex-md-row">
                  <div className="upload_button_section">
                    <Upload
                      onChange={(e) => {
                        handleFileUpload(e);
                      }}
                      accept={accept}
                    >
                      <div className={cs}>
                        <div className="bg_master2 px-4 br_5  py-2">
                          <div className="acro_custom_icon d-flex align-items-center justify-content-center">
                            <IconPlus />
                            <div className="text-white ms-2">Upload files</div>
                          </div>
                        </div>
                      </div>
                    </Upload>
                  </div>
                  {/* Camera Capture Button */}

                  {!MENUSWITHOUTCAPTUREOPTION?.includes(selectedMenu) && (
                    <div className="cursor-pointer">
                      <div
                        className="bg_master2 px-4 br_5 text-white py-2"
                        onClick={onCameraCapture}
                      >
                        <i className="fas fa-camera me-2"></i>
                        Capture with Camera
                      </div>
                    </div>
                  )}
                </div>

                <div>
                  {currentPath === "/transcom_Pdf_Extraction" ||
                  currentPath === "/Pdf_Extraction" ? (
                    <h3 className="text_master2 font_15 pt-2 mb-0 text-center">
                      Upload digital pdf files of size less than 3 MB
                    </h3>
                  ) : selectedMenu === "PRESCRIPTIONOCR" ? (
                    <h3 className="text_master2 font_15 pt-2 mb-0 text-center">
                      Note: Upload jpeg, jpg and png files of size less than 50
                      MB
                    </h3>
                  ) : selectedMenu === "MEDICALREPORT" ? (
                    <h3 className="text_master2 font_15 pt-2 mb-0 text-center">
                      Note: Upload pdf, jpeg, jpg and png files of size less
                      than 10 MB
                    </h3>
                  ) : currentPath === "/canadian_DL" ? (
                    <h3 className="text_master2 font_15 pt-2 mb-0 text-center">
                      Note: Upload jpeg, jpg and png files of size less than 3
                      MB
                    </h3>
                  ) : currentPath === "/account_opening_formExtractor" ? (
                    <h3 className="text_master2 font_15 pt-2 mb-0 text-center">
                      Note: pdf files of size less than 3 MB
                    </h3>
                  ) : (
                    <h3 className="text_master2 font_15 pt-2 mb-0 text-center">
                      Note: Upload jpeg, jpg, png & pdf files of size less than
                      3 MB
                    </h3>
                  )}
                </div>
                {DIRECTAIMENUS?.includes(selectedMenu) ? (
                  <></>
                ) : (
                  <div>
                    <span className="d-block mt-2 mb-3">Or</span>

                    <p className="text_gray7">Choose from existing samples</p>

                    <div className="d-flex flex-column mb-1 flex-md-row gap-2 flex-wrap">
                      {/* <button className='btn btn-master2 font_14 py-2'>Resume Sample</button>
                  <button className='btn btn-master2 font_14 py-2'>Resume Sample</button> */}
                      {Loader ? (
                        <Skeleton
                          count={4}
                          height={40}
                          width={90}
                          inline={true}
                          baseColor="#1A82E2"
                          highlightColor="#5fa8ec"
                          className="btn btn-master2 font_14 py-2 m-1"
                        />
                      ) : dataList.length > 0 ? (
                        dataList.map((itm, index) => (
                          <button
                            className="btn btn-master2 font_14 py-2"
                            key={index}
                            onClick={() => {
                              handleSelect(itm, index);
                            }}
                          >
                            Sample {index + 1}
                          </button>
                        ))
                      ) : (
                        <></>
                      )}
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Uploadfiles;
